import { commitPresetSession } from '@src/utils/presets/transientPreset';
import { useMutation } from '@tanstack/react-query';
import { updateDashboard } from '@src/api/dashboards';

function useUpdateDashboard() {
  const updateMutation = useMutation(updateDashboard, {
    onSuccess: (_data, variables) => commitPresetSession(variables.id),
  });

  return { updateMutation };
}

export default useUpdateDashboard;
